export const getCurrentLocale = () => {
  return localStorage.getItem('locale') || 'en';
};
